import "./Contact.module.css";
import Nagłówek from "@/reusable_sections/Header";
import ZnajdzNasIZapytaj from "./sections/ZnajdzNasIZapytaj";
import FindUsInBialystok from "./sections/FindUsInBialystok";
import TrainerFooter from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Nagłówek />
      <ZnajdzNasIZapytaj />
      <FindUsInBialystok />
      <TrainerFooter />
    </div>;
}